import { motion } from "framer-motion";

export const InvoiceItemsTable = ({ items }) => {
  return (
    <motion.div
      className="bg-gradient-to-br from-gray-100 to-gray-50 p-8 rounded-2xl shadow-xl mt-6 border border-gray-200"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {/* Heading */}
      <h3 className="text-3xl font-extrabold text-gray-800 mb-6 tracking-wide text-center">
        Invoice Items
      </h3>

      {/* Table Wrapper for Responsive Scrolling */}
      <div className="overflow-x-auto rounded-lg border border-gray-300 shadow-md">
        <motion.table
          className="w-full border-collapse"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          {/* Table Head */}
          <thead>
            <motion.tr
              className="bg-gradient-to-r from-blue-600 to-blue-800 text-white text-left"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {[
                "S.NO",
                "ITEM",
                "DESCRIPTION",
                "QTY",
                "RATE",
                "DISC",
                "Price After Disc",
                "VAT %",
                "VAT Amt",
                "Total Amt",
              ]?.map((head) => (
                <th
                  key={head}
                  className="px-4 py-3 text-sm font-semibold uppercase tracking-wide border-r border-blue-400 last:border-r-0"
                >
                  {head}
                </th>
              ))}
            </motion.tr>
          </thead>

          {/* Table Body */}
          <motion.tbody>
            {items?.map((item, index) => (
              <motion.tr
                key={index}
                className={`text-gray-800 text-md ${ 
                  index % 2 === 0 ? "bg-gray-50" : "bg-white"
                } hover:bg-blue-50 transition-all duration-300`}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.1 }}
                whileHover={{ scale: 1.02 }}
              >
                <td className="px-4 py-3 border-r border-gray-300">{index+1}</td>
                <td className="px-4 py-3 border-r border-gray-300">{item.itemCode}</td>
                <td className="px-4 py-3 border-r border-gray-300">{item.description}</td>
                <td className="px-4 py-3 border-r border-gray-300 text-center">{item.quantity}</td>
                <td className="px-4 py-3 border-r border-gray-300 text-right">{item.rate}</td>
                <td className="px-4 py-3 border-r border-gray-300 text-center">{item.discount}</td>
                <td className="px-4 py-3 border-r border-gray-300 text-right">{item.priceAfterDiscount}</td>
                <td className="px-4 py-3 border-r border-gray-300 text-center">{item.vatPercentage}%</td>
                <td className="px-4 py-3 border-r border-gray-300 text-right">{item.vatAmount}</td>
                <td className="px-4 py-3 font-bold text-right">{item.totalAmount}</td>
              </motion.tr>
            ))}
          </motion.tbody>
        </motion.table>
      </div>
    </motion.div>
  );
};
